/**
 * Dynamic module loader.
 *
 * Given a list of module descriptors (from offer.manifest.json), lazily
 * imports each corresponding slice under src/modules/<name>/ and returns
 * the assembled module definitions (routes, menu, providers).
 *
 * Uses Vite's glob import with eager: false so each module is code-split
 * into its own chunk (see vite.config.js > manualChunks).
 */
const modulesImporters = import.meta.glob('../modules/*/index.js');

export async function loadModules(manifestModules) {
  if (!Array.isArray(manifestModules)) return [];

  const loaded = await Promise.all(
    manifestModules.map(async (desc) => {
      const key = `../modules/${desc.name}/index.js`;
      const importer = modulesImporters[key];
      if (!importer) {
        console.warn(`[moduleLoader] module "${desc.name}" has no frontend slice at ${key}`);
        return null;
      }
      try {
        const mod = await importer();
        const def = mod.default || mod;
        return { ...def, manifest: desc };
      } catch (err) {
        console.error(`[moduleLoader] failed to import module "${desc.name}"`, err);
        return null;
      }
    }),
  );
  return loaded.filter(Boolean);
}
